/**
 * useNightModeSync Hook
 * 
 * Observes GameSettingsContext nightMode toggle state and applies/removes Night Mode CSS filters.
 * Synchronizes browser-side filter application with React state changes.
 * 
 * Usage:
 *   useNightModeSync();
 */

import { useEffect } from 'react';
import { useGameSettings } from '@/contexts/GameSettingsContext';
import { toggleNightMode } from '@/utils/nightModeManager';

export function useNightModeSync() {
  const { settings } = useGameSettings();
  const nightMode = settings.themeMode === 'dark';

  useEffect(() => {
    // Apply or remove Night Mode filter based on state
    toggleNightMode(nightMode);
    
    console.log(`[useNightModeSync] Night Mode ${nightMode ? 'enabled' : 'disabled'}`);
  }, [nightMode]);
}
